import React from "react";
export default function FinalCta() {
  return (
    <section className="final-cta-section">
      <div className="container-selectezi">
        <div className="final-cta-panel">
          <span className="eyebrow-badge on-dark">
            <span className="dot" />
            Active Enterprise Infrastructure
          </span>

          <h3 className="mx-auto text-white mt-2">Your Business Your Products Your Market</h3>

          <p className="lead">
            Build your Showcase. Keep your business visible. Discover
            relevant connections and opportunities through SELECTEZI.
          </p>

          <button
            type="button"
            className="btn-selectezi-light mt-4"
            disabled
          >
            Explore SELECTEZI
            <i className="bi bi-arrow-right" />
          </button>

          <p className="keywords">
            Show What You Have &bull; Find What You Need &bull; Promote What
            You Offer &bull; Connect With Opportunities &bull; Grow Your
            Business
          </p>
        </div>
      </div>
    </section>
  );
}
